export default {
  query: []
}